export default {
  tips: "We've sent an activation code to your email. (please check your spam, if you haven't received any email).",
  verifyEmail: 'Activate account',
  securityCode: 'Security code',
  sendAgain: 'Send again',
  second: '{second}s...',
  title: 'Check your email',

  //
  backLogin: 'back',
  tokenEmpty: 'Security code cannot empty',
  passSended: 'Password Reset Link Sent to Your Email',
  activatingEmail:
    'We’ve sent a security code to your email. (if you can’t find it, check your Spam).',
  activate: 'Activate',
  emailValidationSuccess: 'Email verified',
  emailValidationFailure:
    'Email verification failed, please click on send again to receive another verification email',
}
